<template>
  <div class="pie-chart-component">
    <div class="pie animate" :style="style">{{ progress }}%</div>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 100
    },
    changePoint: {
      type: Number,
      default: 60
    }
  },
  computed: {
    color() {
      if (this.progress < this.changePoint) {
        return "#E06872";
      }

      return "#3e56ac";
    },
    style() {
      return `--p:${this.progress};--c:${this.color}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.pie-chart-component {
  @property --p {
    syntax: "<number>";
    inherits: true;
    initial-value: 0;
  }

  .pie {
    --p: 20;
    --b: 14px;
    --c: darkred;
    --w: 150px;
    --backdrop: #bebfc7;

    width: var(--w);
    aspect-ratio: 1;
    position: relative;
    display: inline-grid;
    margin: 5px;
    place-content: center;
    font-size: 24px;
    font-weight: bold;
    font-family: sans-serif;
  }
  .pie:before,
  .pie:after {
    content: "";
    position: absolute;
    border-radius: 50%;
  }
  .pie:before {
    inset: 0;
    background: radial-gradient(farthest-side, var(--c) 116%, #0000)
        top/var(--b) var(--b) no-repeat,
      conic-gradient(var(--c) calc(var(--p) * 1%), var(--backdrop) 0);
    -webkit-mask: radial-gradient(
      farthest-side,
      #0000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
    mask: radial-gradient(
      farthest-side,
      #0000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
  }
  .pie:after {
    inset: calc(50% - var(--b) / 2);
    border-radius: 35%;
    background: var(--c);
    transform: rotate(calc(var(--p) * 3.6deg))
      translateY(calc(50% - var(--w) / 2));
  }
  .animate {
    animation: p 2 ease-in;
  }
  .no-round:before {
    background-size: 0 0, auto;
  }
  .no-round:after {
    content: none;
  }
  @keyframes p {
    from {
      --p: 0;
    }
  }
}
</style>
